module.exports = __webpack_public_path__ + "img/C75F55_F8BDA9_EB9484_F4A494-256px.6ade1747.png";